/* eslint-disable */

import axios from "axios";
import moment from "moment";
import { tz } from "../../../utils/timezone";

const url = require("../../client_config/config").url;

const state = {
  
};

const getters = {
  
};

const actions = {

  async downloadCaseManagementReport({ commit }, data) {

    try {
      const response = await axios.get(`${url}/caseManagement/download-report/${data.startDate}/${data.endDate}/${data.clientID}`, {
        params: data,
        responseType: 'arraybuffer'
      }
    );
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },
};

const mutations = {
  
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};